import { DrawerSvcc } from '../../../../components/drawer/DrawerSvcc';
import { useGetCIIUCodesQuery } from '../../../../../../services/companyApi';
import { ContractorFormDrawer } from './ContractorFormDrawer';
import { ResponsibleFormDrawer } from './ResponsibleFormDrawer';

export const RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES = {
    NEW_CONTRACTOR: 'NEW_CONTRACTOR',
    EDIT_CONTRACTOR: 'EDIT_CONTRACTOR',
    NEW_RESPONSIBLE: 'NEW_RESPONSIBLE',
    EDIT_RESPONSIBLE: 'EDIT_RESPONSIBLE'
};

const DrawerManager = ({ open, setOpen, selected, contractorsState, responsiblesState, onlyVisual }: any) => {

    const handleCloseDrawer = () => {
        setOpen('');
    };

    const DrawerInputManager = () => {
        switch (open) {
            case RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.NEW_CONTRACTOR:
                return (
                    <ContractorFormDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selected={selected}
                        isEditing={false}
                        contractorsState={contractorsState}
                        onlyVisual={onlyVisual}
                    />
                );
            case RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.EDIT_CONTRACTOR:
                return (
                    <ContractorFormDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selected={selected}
                        isEditing={true}
                        contractorsState={contractorsState}
                        onlyVisual={onlyVisual}
                    />
                );
            case RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.NEW_RESPONSIBLE:
                return (
                    <ResponsibleFormDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selected={selected}
                        isEditing={false}
                        responsiblesState={responsiblesState}
                        onlyVisual={onlyVisual}
                    />
                );
            case RESPONSIBLES_AND_CONTRACTORS_DRAWER_ACTION_VALUES.EDIT_RESPONSIBLE:
                return (
                    <ResponsibleFormDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selected={selected}
                        isEditing={true}
                        responsiblesState={responsiblesState}
                        onlyVisual={onlyVisual}
                    />
                );
            default:
                return <></>;
        }
    };

    return (
        <DrawerSvcc open={!!open} onClose={handleCloseDrawer} ancho={560}>
            <DrawerInputManager />
        </DrawerSvcc>
    );
};

export default DrawerManager;
